module.exports = __webpack_public_path__ + "img/0.4afc33c8.png";